<template>
  <div class="p-images" v-if="product" :class="{'hide-bottom': (product.downPayment && product.downPayment.discount)}">
    <div class="detail-menu-wrap" v-if="!isApp && !nocache">
      <menu-tab />
    </div>
    <i v-show="product" v-if="!isApp && !nocache" class="icon" :class="favoriteClass" @click="favorite"></i>
    <swiper 
      :config="swiper"
      :paginateCls="swiper.paginateCls">
      <div class="swiper-slide" v-if="product.videos.length" v-for="(video, index) in product.videos">
        <div class="product-video" :class="'p' + index">
          <beast-video
            :wrap="'p' + index"
            :isHeight="true"
            :poster="ensureImage(video.thumbnailUrl)"
            :autoplay="false"
            :source="video.url"
            :controls="true"
          />
        </div>
      </div>
      <div v-for="item in product.images" class="swiper-slide">
        <!-- <img :src="item"> -->
        <div class="mask" v-if="soldOut"></div>
        <beast-image :src="ensureImage(item)" />
        <div class="stats-tag buyable" v-if="!product.invisible && !product.buyable">
          <span>该渠道不可售</span>
        </div>
        <div class="stats-tag" v-if="product.foretell">
          <span>即将开售</span>
        </div>
        <div class="stats-tag" v-if="soldOut">
          <span>售罄</span>
        </div>
        <div class="stats-tag" v-if="(!nocache && product.offShelf) || product.invisible">
          <span>下架</span>
        </div>
       
      </div>
    </swiper>

    <div class="toast-box" v-if="isToast">
      <h2>{{ toastTitle }}</h2>
      <p>{{ toastContent }}</p>
    </div>
    <div class="forecast-detail" v-if="!product.prevue && djsformat">
      <span class="forecast-detail-name">限时抢购</span>
      <span class="forecast-detail-price">{{djsformat}} 后恢复原价</span>
    </div>
    <div class="forecast-detail forecast-ys" v-if="product.prevue">
      <div class="left-box">
        <div class="forecast-detail-item name">即将开售: {{ prevueFormatNew }} 开售</div>
        <div class="forecast-detail-item desc" v-if="product.prevue.desc">{{ product.prevue.desc }}</div>
      </div>
      <div class="right-box">
        <span class="forecast-detail-price" :class="{'two': product.prevue.desc}"
          @click="doReminder(product.prevue.id, product.prevue.remind)">
          {{ product.prevue.remind ? '关闭提醒' : '开售提醒'}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { ensure_protocol } from '@beastshop/url-util'
import browser from '@beastshop/browser'

import Swiper from '@/swiper/swiper-4.4.6/index.vue'
import BeastImage from '@/components/image/'
import BeastVideo from '@/components/video/'
import MenuTab from '@/components/menu-tab'

import {
  foreShow
} from '../api.js'

let _rush_count_down = null

export default {
  props: ['product', 'djsformat', 'nocache'],

  components: {
    Swiper,
    BeastImage,
    BeastVideo,
    MenuTab
  },

  data () {
    return {
      isApp: browser.app(),
      showPriceFloor: false,
      prevueFormat: null,
      prevueFormatNew: null,
      isToast: false,
      toastTitle: null,
      toastContent: null,
      swiper: {
        pagination: {
          el: '.swiper-pagination', 
          type: 'fraction',
        },
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        paginateCls: { 'number-paginate': true },
        // paginateCls: 'number-paginate',
        // autoplay: 3000,
        autoplayDisableOnInteraction: false
      }
    }
  },

  created () {
    if (!this.product) return
    this.getCountDown()
    this.formatTime()
  },

  computed: {
    favoriteClass: function() {
      return this.product && this.product.favorited ?
        'icon-like-active' :
        'icon-like'
    },

    soldOut () {
      if (!this.product) return false
      const downPay = this.product.downPayment || null

      if (!downPay) return this.product.soldOut

      let soldOut = true
      downPay.details.forEach(spv => {
        if (spv.stock > 0) {
          soldOut = false
        }
      })

      if (this.product.soldOut && soldOut) {
        soldOut = true
      }
      else if (this.product.soldOut && !soldOut) {
        soldOut = false
      }
      else {
        soldOut = false
      }

      return soldOut
    }
  },

  methods: {
    favorite () {
      this.$emit('favorite')
    },

    doReminder (id, reminded) {
      const d = {
        productCode : this.product.id,
        productName: this.product.name,
        id,
        reminded
      }

      this.$ensureLogged({
        event: '开售提醒'
      })
      .then(() => {
        foreShow(d)
        .then(data => {
          if (!reminded) {
            this.product.prevue.remind = true
            this.toastTitle = data.title
            this.toastContent = data.message
            this.isToast = true

            setTimeout(() => {
              this.isToast = false
            }, 2000)
          }
          else {
            this.toastTitle = data.title
            this.toastContent = ''
            this.isToast = true

            setTimeout(() => {
              this.isToast = false
            }, 2000)
            this.product.prevue.remind = false
          }

        })
        .catch(err => {
          this.$toast(`${err.message}`)
        })
      })
      .catch(() => {
        // sa.registerButtonClick()
      })
    },

    getCountDown: function() {
      // let endDate = new Date(this.product.prevue.since) , _now = new Date()
      if(!this.product.prevue || !this.product.prevue.vipSince) {
        return
      }
      let endDate = new Date(this.product.prevue.vipSince) , _now = new Date()
      let leftTime =endDate.getTime()/1000 -_now.getTime()/1000,
          leftsecond = parseInt(leftTime),
          day1=Math.floor(leftsecond/(60*60*24)),
          hour=Math.floor((leftsecond-day1*24*60*60)/3600),
          minute=Math.floor((leftsecond-day1*24*60*60-hour*3600)/60),
          second=Math.floor(leftsecond-day1*24*60*60-hour*3600-minute*60)

      if(hour==0&&minute==0&&second==0){
        this.prevueFormat = null
        clearTimeout(_rush_count_down)
        window.location.reload()
        return false
      }

      if (day1 == 0) {
        this.prevueFormat = `距离开售还有${hour}小时${minute}分${second}秒`
      }
      else {
        this.prevueFormat = `距离开售还有${day1}天${hour}小时${minute}分${second}秒`
      }

      _rush_count_down = setTimeout(() => {this.getCountDown()},1000);
    },

    formatTime () {
      if(!this.product.prevue || !this.product.prevue.since) {
        return
      }
      let date = new Date(parseInt(this.product.prevue.since, 10))
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hh = date.getHours()
      let mm = date.getMinutes()
      let ss = date.getSeconds()

      month = this.addZero(month)
      day = this.addZero(day)
      hh = this.addZero(hh)
      mm = this.addZero(mm)
      ss = this.addZero(ss)
      let timeStr = `${month}月${day}日 ${hh}:${mm}:${ss}`
      this.prevueFormatNew = timeStr
    },

    addZero (str) {
      if(str < 10) {
        str = "0"+str
      }
      return str
    },

    ensureImage (src) {
      return ensure_protocol(src)
    },
  }
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// product-images.vue?1685ba9c